import { SELECTORS } from './constants';

export class PurchaseBar {
  constructor(container) {
    this.navLinks = container.querySelectorAll(`.${SELECTORS.NAV_LINK}`);
    this.sections = [];

    this.initSections();
  }

  initSections() {
    this.navLinks.forEach((link) => {
      const href = link.getAttribute('href');

      if (href?.startsWith('#')) {
        const section = document.querySelector(href);

        if (section) {
          this.sections.push({ href, section });
        }
      }
    });
  }

  setActiveLink(href) {
    this.navLinks.forEach((link) => {
      const isTarget = link.getAttribute('href') === href;
      const isDefault = !href && link.classList.contains(SELECTORS.NAV_LINK_DEFAULT);

      link.classList.toggle(SELECTORS.NAV_LINK_ACTIVE, isTarget || isDefault);
    });
  }

  onScroll = () => {
    const currentSection = this.sections.find(({ section }) => {
      const rect = section.getBoundingClientRect();

      return rect.top <= 100 && rect.bottom >= 100;
    });

    this.setActiveLink(currentSection?.href);
  };

  initializeEventListeners() {
    window.addEventListener('scroll', this.onScroll);
  }
}
